import { useEffect, useRef, useState } from "react";

const useInfiniteScroll = () => {
  // 보여지고 있는지를 나타내는 state
  const [isVisible, setIsVisible] = useState(false);
  const [reRender, setRerender] = useState(false);

  const targetRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      setIsVisible(entry.isIntersecting);
    });
    if (targetRef.current) {
      observer.observe(targetRef.current);
    }
    return () => {
      observer.disconnect();
    };
  }, [isVisible, reRender]);

  return { isVisible, targetRef, setIsVisible, setRerender };
};

export default useInfiniteScroll;
